/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tab_OrdersInputs */

const en_shop_tab_orders = /** @type {(inputs: Shop_Tab_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const pl_shop_tab_orders = /** @type {(inputs: Shop_Tab_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamówienia`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Shop_Tab_OrdersInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_tab_orders = /** @type {((inputs?: Shop_Tab_OrdersInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tab_OrdersInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_tab_orders(inputs)
	return en_shop_tab_orders(inputs)
});